import OrganisationLayout from "../../../components/organisation/layout/OrganisationLayout";
import { Formik } from "formik";
import {
  BaseButton,
  BaseInput,
  BaseSelect,
  BaseAddressSelect,
  BaseCheckbox,
  Spinner,
} from "../../../components/base";
import { useState, useEffect } from "react";
import { CollectionTimeRange } from "../../../data/utils";
import { fetchAllStatesAction } from "../../../store/slices/util/action";
import { findOrganisationBranchesAction } from "../../../store/slices/organisation/action";
import { saveNewBookingData } from "../../../store/slices/organisation";
import { useNavigate } from "react-router-dom";
import BaseToggleButton from "../../../components/base/BaseToggleButton";
import { useAppDispatch, useAppSelector } from "../../../store";
import { AddressType } from "../../../enums/address-type.enum";
import { StateData } from "../../../store/slices/util/types";
import { AppointmentType } from "../../../enums/appointment-type.enum";
import { saveBeneficiaryDetails } from "../../../store/slices/customer";

function AppointmentDetails() {
  const [formValue, setFormValue] = useState<{
    proposedAppointmentTimeFrame: { id: string; name: string };
    state: StateData;
    manualAddress: boolean;
    address: string;
    selectAddress: { name: string; id: string };
  }>({
    proposedAppointmentTimeFrame: { id: "", name: "" },
    state: {
      _id: "",
      id: "",
      name: "",
      logisticsFee: 0,
      logisticsFeePerOperation: [],
    },
    manualAddress: false,
    address: "",
    selectAddress: { name: "", id: "" },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<{
    proposedAppointmentTimeFrame: string;
    stateError: string;
    googleAddress: string;
    manualAddress: string;
    proposedAppointmentDate: string;
  }>({
    proposedAppointmentTimeFrame: "",
    stateError: "",
    googleAddress: "",
    manualAddress: "",
    proposedAppointmentDate: "",
  });
  const [isPickUp, setIsPickUp] = useState(false);
  const [isWalkIn, setIsWalkIn] = useState(false);
  const [resetGoogleAddress, setResetGoogleAddress] = useState(0);
  const [resetManualAddress, setResetManualAddress] = useState(0);
  const [addressType, setAddressType] = useState<{
    id: AddressType | string;
    name: string;
  }>({
    id: AddressType.CustomerAddress,
    name: "Customer's Address",
  });
  const { allStates } = useAppSelector((state) => state.utilReducer);
  const { organisationBranches, newBookingData, loading } = useAppSelector(
    (state) => state.organisationReducer
  );
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );
  
  const { bookingBeneficiaryDetails } = useAppSelector(
    (state) => state.customerReducer
  );

  const router = useNavigate();

  const dispatch = useAppDispatch();

  const sampleCollectionDetailsObj = {
    proposedAppointmentDate: "",
    proposedAppointmentTimeFrame: "",
    state: "",
    manualAddress: "",
    address: "",
    selectAddress: "",
    externalReference: "",
    dateOfBirth: "",
  };

  const addressTypes = [
    { id: AddressType.CustomerAddress, name: "Customer's Address" },
    { id: AddressType.WalkIn, name: "Walk in to Lab" },
  ];

  const toggleAddressType = (addressType: {
    id: AddressType | string;
    name: string;
  }) => {
    const isWalkIn = addressType.id === AddressType.WalkIn;

    // const stateObj = allStates.find((state) => state.name === "Lagos");

    // const walkInState = stateObj || formValue.state;

    setAddressType(addressType);
    setIsPickUp(isPickUp);
    setIsWalkIn(isWalkIn);
    setFormValue((prevState) => ({
      ...prevState,
      address: "",
    }));
  };


  const selectState = async (obj: any) => {
    setFormValue((prevState) => ({
      ...prevState,
      state: obj,
    }));

    setErrorMsg((prevState) => ({
      ...prevState,
      stateError: "",
    }));
  };
  const selectOrgAddress = async (obj: any) => {
    setFormValue((prevState) => ({
      ...prevState,
      selectAddress: obj,
      address: "",
    }));
    setErrorMsg((prevState) => ({
      ...prevState,
      addressError: "",
    }));
  };
  const selectCollectionDate = (obj: any) => {
    setFormValue({ ...formValue, proposedAppointmentTimeFrame: obj });
    setErrorMsg({ ...errorMsg, proposedAppointmentTimeFrame: "" });
  };

  const handleChangeAddress = (address: any) => {
    setFormValue((prevState) => ({
      ...prevState,
      selectAddress: { name: "", id: "" },
      address: address?.formatted_address,
    }));
    setErrorMsg((prevState) => ({
      ...prevState,
      googleAddress: "",
    }));
  };

  const tickIsManualEntry = (e: any) => {
    setFormValue({
      ...formValue,
      manualAddress: e.target.checked,
      address: "",
    });
    setResetGoogleAddress((prevState) => prevState + 1);
    setResetManualAddress((prevState) => prevState + 1);
  };
  const validateDetails = (values: any) => {
    let errors: any = {};

    if (!values.proposedAppointmentDate) {
      errors.proposedAppointmentDate = "Sample collection date cannot be blank";
    }

    if (!bookingBeneficiaryDetails?.dateOfBirth && !values.dateOfBirth) {
      errors.dateOfBirth = "Date of birth cannot be blank";
    }

    if (!formValue?.proposedAppointmentTimeFrame?.name) {
      errors.proposedAppointmentTimeFrame = "Please, select collection time";
      setErrorMsg((prevState) => ({
        ...prevState,
        proposedAppointmentTimeFrame: "Please, select collection time",
      }));
    }

    if (!formValue?.state?.name) {
      setErrorMsg((prevState) => ({
        ...prevState,
        stateError: "Please select a state",
      }));
    }

    if (!formValue?.address && !formValue.manualAddress && !isPickUp) {
      errors.googleAddress = "Address cannot be blank.";

      setErrorMsg((prevState) => ({
        ...prevState,
        googleAddress: "Address cannot be blank",
      }));
    }
    if (!formValue?.address && formValue.manualAddress && !isPickUp) {
      errors.manualAddress = "Address cannot be blank.";

      setErrorMsg((prevState) => ({
        ...prevState,
        manualAddress: "Address cannot be blank",
      }));
    }
    if (formValue.manualAddress && !isPickUp) {
      setErrorMsg((prevState) => ({
        ...prevState,
        googleAddress: "",
        selectAddress: "",
      }));

      setFormValue((prevState) => ({
        ...prevState,
        selectAddress: { name: "", id: "" },
      }));

      if (!formValue.address) {
        errors.address = "Address cannot be blank";
      }
    }
    if (isPickUp) {
      setErrorMsg((prevState) => ({
        ...prevState,
        googleAddress: "",
      }));

      setFormValue((prevState) => ({
        ...prevState,
      }));

      if (!formValue.selectAddress) {
        errors.address = "Address cannot be blank";
      }
    }

    return errors;
  };
  const handleChang = (e: { target: { value: any } }) => {
    setFormValue((prevState) => ({
      ...prevState,
      address: e.target.value,
      selectAddress: { name: "", id: "" },
    }));
  };

  const onProceed = async (values: any, { resetForm }: { resetForm: any }) => {
    dispatch(
      saveNewBookingData({
        ...newBookingData,
        appointmentDetails: {
          appointmentType: isWalkIn
            ? AppointmentType.WalkIn
            : AppointmentType.HomeService,
          proposedAppointmentDate: values?.proposedAppointmentDate,
          proposedAppointmentTime:
            formValue?.proposedAppointmentTimeFrame?.name,
          state: formValue?.state,
          lineOfAddress: isPickUp
            ? formValue?.selectAddress?.name
            : formValue?.address,
          isWalkIn,
        },
        externalReference: values?.externalReference,
      })
    );

    if (values?.dateOfBirth) {
      dispatch(
        saveBeneficiaryDetails({
          ...bookingBeneficiaryDetails,
          dateOfBirth: values?.dateOfBirth,
        })
      );
    }

    router("/dashboard/booking/complete-booking");
  };

  const getAllStates = () => {
    dispatch(fetchAllStatesAction());
  };

  const getAllBranches = () => {
    if (addressType.id === AddressType.PickUp) {
      dispatch(
        findOrganisationBranchesAction(
          currentOrganisationAccount?.organisationId || ""
        )
      );
    }
  };

  useEffect(() => {
    getAllStates();
  }, []);

  useEffect(() => {
    getAllBranches();
  }, [addressType]);

  return (
    <>
      <OrganisationLayout>
        {loading ? (
          <Spinner spinnerText={""} styles={""} />
        ) : (
          <div className="px-3 lg:w-2/3 lg:px-12 mt-5">
            <div className="mb-4">
              <h1 className="text-[#525256] text-[1.25rem] font-[700] mb-2">
                Appointment Details{" "}
              </h1>
              <p className="text-[#525256] text-[0.875rem] font-[400]">
                Please input the appointment details
              </p>
            </div>
            <div className="w-fit mb-6 rounded bg-[#F2F6FA] p-2 text-[#6B7381]">
              <BaseToggleButton
                items={addressTypes}
                activeTab={addressType}
                setActiveTab={toggleAddressType}
              />
            </div>
            <Formik
              initialValues={sampleCollectionDetailsObj}
              enableReinitialize={true}
              onSubmit={onProceed}
              validate={validateDetails}
              // innerRef={formikRef}
            >
              {(formik) => {
                const {
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                } = formik;
                return (
                  <form onSubmit={handleSubmit} className="mb-4">
                    <div className="sm:grid sm:grid-cols-2 sm:gap-5">
                      {
                        <div className="col-span-2 mb-6 sm:mb-2">
                          <div>
                            <div className="sm:grid sm:grid-cols-2 sm:gap-5">
                              <BaseInput
                                id={"proposedAppointmentDate"}
                                value={values.proposedAppointmentDate}
                                label="Appointment Date"
                                name={"proposedAppointmentDate"}
                                type="date"
                                hasError={
                                  errors.proposedAppointmentDate &&
                                  touched.proposedAppointmentDate
                                }
                                change={handleChange}
                                styleClass="mb-6 sm:mb-2"
                                min={new Date().toISOString().split("T")[0]}
                                errorMsg={errors.proposedAppointmentDate}
                              />
                              <BaseSelect
                                // id={"proposedAppointmentTimeFrame"}
                                label="Appointment Time"
                                name={"proposedAppointmentTimeFrame"}
                                value={formValue.proposedAppointmentTimeFrame}
                                hasError={
                                  !!errorMsg.proposedAppointmentTimeFrame &&
                                  touched.proposedAppointmentTimeFrame
                                }
                                styleClass="mb-6 sm:mb-2"
                                errorMsg={errorMsg.proposedAppointmentTimeFrame}
                                onChange={selectCollectionDate}
                                options={CollectionTimeRange}
                                selectKey="name"
                                textClass={""}
                                filter={false}
                                showClear={false}
                                inputId={""}
                              />
                              <BaseSelect
                                // id={"state"}
                                value={formValue?.state}
                                label="State"
                                name={"state"}
                                filter={true}
                                styleClass="mb-6 sm:mb-2"
                                hasError={
                                  !!errorMsg.stateError && touched.state
                                }
                                errorMsg={errorMsg.stateError}
                                onChange={selectState}
                                options={allStates}
                                selectKey="name"
                                textClass={""}
                                showClear={false}
                                inputId={""}
                              />

                              {formValue?.manualAddress ? (
                                <BaseInput
                                  id="manualAddress"
                                  label="Enter a Address"
                                  name="manualAddress"
                                  change={handleChang}
                                  type={"text"}
                                  disabled={!formValue?.manualAddress}
                                  value={formValue?.address}
                                  hasError={
                                    !!errorMsg.manualAddress && touched.address
                                  }
                                  errorMsg={errorMsg.manualAddress}
                                />
                              ) : (
                                <BaseAddressSelect
                                  key={resetGoogleAddress}
                                  value={formValue?.address}
                                  id="googleAddress"
                                  label={
                                    isWalkIn
                                      ? "Enter walk in address"
                                      : "Enter Address"
                                  }
                                  // name="googleAddress"
                                  onSelect={handleChangeAddress}
                                  disabled={
                                    formValue?.manualAddress || !!isWalkIn
                                  }
                                  hasError={
                                    !!errorMsg.googleAddress &&
                                    touched.address &&
                                    !formValue.manualAddress
                                  }
                                  errorMsg={errorMsg.googleAddress}
                                  styleClass={""}
                                />
                              )}
                              {
                                <div className="flex w-full my-2 sample_dropdown items-center">
                                  <BaseCheckbox
                                    // inputId="manualAddress"
                                    // value={formValue?.manualAddress}
                                    // name="manualAddress"
                                    change={tickIsManualEntry}
                                    checked={formValue?.manualAddress}
                                    children={undefined}
                                    labelClasses={""}
                                    id={"manualAddress"}
                                    disabled={false}
                                  />
                                  <label
                                    htmlFor="manualAddress"
                                    className="primary_text_color text-[14px] font-normal  ml-3 leading-6"
                                  >
                                    Enter Address Manually
                                  </label>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      <BaseInput
                        id={"externalReference"}
                        value={values.externalReference}
                        label="External Reference (Optional)"
                        name={"externalReference"}
                        type="text"
                        change={handleChange}
                        styleClass="mb-6 sm:mb-2"
                      />

                      {!bookingBeneficiaryDetails?.dateOfBirth && (
                        <div className="mb-6">
                          <BaseInput
                            id={"dateOfBirth"}
                            value={values.dateOfBirth}
                            label="Date of Birth"
                            name={"dateOfBirth"}
                            type="date"
                            hasError={errors.dateOfBirth && touched.dateOfBirth}
                            change={handleChange}
                            blur={handleBlur}
                            bodyStyles="mb-1"
                            errorMsg={errors.dateOfBirth}
                          />
                          <span className="text-base font-medium">
                            ***Add beneficiary's date of birth
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="lg:w-2/6 pt-4">
                      <BaseButton
                        text="Proceed"
                        styles="w-full sm:w-1/2 lg:w-full h-[53px] rounded-[70px] !text-white font-[500] border-0 !text-[1rem] textbrandColor"
                        type="submit"
                        variant="primary"
                        processing={isLoading}
                      />
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        )}
      </OrganisationLayout>
    </>
  );
}

export default AppointmentDetails;
